import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-collapse-toggle',
  templateUrl: './collapse-toggle.component.html',
  standalone: false,
})
export class CollapseToggleComponent {
  @Output() activeChange = new EventEmitter<boolean>();
  @Input() active = true;

  icon = AppIcon;
  iconSize = AppIconSize;
  iconColor = AppIconColor;
}
